import BackToTopButtonElement from './handles/BackToTopButtonElement';

export interface Props {
	displayThreshold?: number;
	display?: Display;
	componentId?: string;
}

type Display = 'button' | 'caret-icon';
const BackToTopButton = (props: Props) => {
	// <BackToTopButtonProvider {...props}>
	return <BackToTopButtonElement {...props} />;
	// </BackToTopButtonProvider>
};

export default BackToTopButton;
